document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('.cw-shipping-usps__item--text');
    if (items.length > 1) {
        items[1].innerHTML = 'Spend £35 and get free shipping';
    }
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.quantity-selector').forEach(function (selector) {
    const minusBtn = selector.querySelector('.quantity-btn--minus');
    const plusBtn = selector.querySelector('.quantity-btn--plus');
    const input = selector.querySelector('.quantity-input');
    const itemKey = input.getAttribute('data-item-key');

    minusBtn?.addEventListener('click', function () {
      let qty = parseInt(input.value, 10);
      if (qty > 1) {
        updateCartQuantity(itemKey, qty - 1, input, minusBtn);
      }
    });

    plusBtn?.addEventListener('click', function () {
      let qty = parseInt(input.value, 10);
      updateCartQuantity(itemKey, qty + 1, input, minusBtn);
    });
  });

  function updateCartQuantity(itemKey, newQty, input, minusBtn) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: newQty })
    })
      .then(res => res.json())
      .then(() => {
        input.value = newQty;
        if (newQty <= 1) {
          minusBtn.setAttribute('disabled', 'disabled');
        } else {
          minusBtn.removeAttribute('disabled');
        }
        // Optionally, reload the page or update cart totals here
        location.reload();
      });
  }
});
